<template>
  <v-row>
    <v-col>
      <h3 class="mb-2">
        {{ $t('common.identity-checking.IdentityCheckingInformation.stepTitle') }}
      </h3>
      <div>
        {{ $t('common.identity-checking.IdentityCheckingInformation.stepText') }}
      </div>
    </v-col>
  </v-row>

  <!-- Information Errors -->
  <div v-if="informationErrors.length > 0" class="my-8">
    <app-alert-in-page v-for="documentError in informationErrors"
                       :key="documentError"
                       class="mt-2"
                       :dismissible="false"
                       variant="error"
    >
      <div v-html="$t('common.idCheckErrors.' + documentError)"/>
    </app-alert-in-page>

    <!-- Tries left -->
    <app-alert-in-page class="mt-2" :dismissible="false" variant="error">
      <template #title>
        {{ $t('common.identity-checking.IdentityCheckingDialog.wrongInfo') }}
      </template>

      <span class="mt-2"
            v-t="{
              path: 'common.identity-checking.IdentityCheckingDialog.triesLeft',
              plural: triesLeft,
              args: { triesLeft: triesLeft },
            }"
      />
    </app-alert-in-page>
  </div>

  <v-row>
    <v-col cols="12" sm="6">
      <Gender :model="information.gender"/>
    </v-col>
  </v-row>
  <v-row>
    <v-col cols="12" sm="6">
      <FirstName :model="information.firstName"/>
    </v-col>
    <v-col cols="12" sm="6">
      <LastName :model="information.lastName"/>
    </v-col>
  </v-row>
  <v-row>
    <v-col cols="12">
      <BirthName :model="information.birthName"/>
    </v-col>
    <v-col cols="12" sm="6">
      <BirthDate :model="information.birthDate"/>
    </v-col>
    <v-col cols="12" sm="6">
      <Telephone :model="information.telephone"
                 :label="$t('common.cellPhoneNumber')"
                 @phone-validation-change="$emit('phone-validation-change', $event)"
      />
    </v-col>
  </v-row>

  <v-row>
    <v-col>
      <div class="text-caption">
        {{ $t('common.identity-checking.IdentityCheckingInformation.requiredFieldsInfo') }}
      </div>
    </v-col>
  </v-row>
</template>

<script>
import { intersection } from 'lodash-es'
import { mapState } from 'vuex'

import { ID_CHECK_INFORMATION_ERRORS } from '@/common/utils/idCheckErrors'

import BirthDate from './form-fields/BirthDate.vue'
import BirthName from './form-fields/BirthName.vue'
import FirstName from './form-fields/FirstName.vue'
import Gender from './form-fields/Gender.vue'
import LastName from './form-fields/LastName.vue'
import Telephone from './form-fields/Telephone.vue'


export default {
  name: 'IdentityCheckingInformation',
  components: {
    BirthDate,
    BirthName,
    FirstName,
    Gender,
    LastName,
    Telephone,
  },
  props: {
    information: {
      type: Object,
      required: true,
    },
    triesLeft: {
      type: Number,
      required: true,
    },
    currentStep: {
      type: Number,
      required: true,
    },
  },
  emits: ['phone-validation-change'],
  computed: {
    ...mapState('user', ['idCheckError']),
    informationErrors () {
      return intersection(this.idCheckError?.errors, ID_CHECK_INFORMATION_ERRORS)
    },
  },
}
</script>
